import { render, staticRenderFns } from "./ImportSkill.vue?vue&type=template&id=a874b812&scoped=true"
import script from "./ImportSkill.vue?vue&type=script&lang=js"
export * from "./ImportSkill.vue?vue&type=script&lang=js"
import style0 from "./ImportSkill.vue?vue&type=style&index=0&id=a874b812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a874b812",
  null
  
)

export default component.exports